module.exports = __webpack_public_path__ + "img/slider1.87fa5f51.svg";